import { render, staticRenderFns } from "./DOMEditor.vue?vue&type=template&id=10078da4&"
import script from "./DOMEditor.vue?vue&type=script&lang=js&"
export * from "./DOMEditor.vue?vue&type=script&lang=js&"
import style0 from "./DOMEditor.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports